<template>
  <div class="Item" :class="{ 
    'Item--active': props.isActive,
    'Item--gifts-grid' : !props.value,
  }">
    <template v-if="props.isPon">
      <div class="Item__pon-item">
        <img class="Item__pon-icon" :src="ponAvatar" height="24px" width="24px" />
        <span class="Item__pon-name">PoN</span>
        <span class="Item__pon-subname">NFT</span>
      </div>
    </template>

    <template v-else>
      <div class="Item__subscribe-item">
        <div class="Item__subscribe-item-grouop">
          <template v-if="props.giftsCount">
            <span class="Item__days">{{ props.giftsCount }}</span>
            <span class="Item__month">{{ giftsLabel }}</span>
          </template>
          <span class="Item__days">{{ props.days }}</span>
          <span class="Item__month">{{ monthLabel }}</span>
        </div>
        <span
          class="Item__tag"
          :class="{
            'Item__tag--primary': props.tagStyle === 'primary',
            'Item__tag--blue-gradient': props.tagStyle === 'blue-gradient',
            'Item__tag--secondary': props.tagStyle === 'secondary',
            'Item__tag--default': props.tagStyle === 'default',
          }"
        >
          {{ props.tag }}
        </span>
      </div>
    </template>

    <span class="Item__price">
      {{ props.price }} <span class="Item__currency">{{ props.currency }}</span>
    </span>

    <span class="Item__value" v-if="props.value">
      {{ props.value }}

      <!-- Добавляем иконку ТОЛЬКО если tagStyle === 'default' -->
      <template v-if="props.tagStyle === 'default'">
        <span class="Item__tooltip-wrapper">
          <infoIcon />
          <span class="Item__tooltip">
            Подписка PoN действует, пока PoN NFT на вашем кошельке
          </span>
        </span>
      </template>
    </span>

    <div class="Item__check" v-if="props.isActive">
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
        <path d="M2.79755 6L0 3.15593L0.699386 2.44491L2.79755 4.57796L7.30061 0L8 0.711019L2.79755 6Z" fill="white" />
      </svg>
    </div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  import { computed } from 'vue';
  //-----------------------------
  import infoIcon from '../icons/infoIcon.vue';
  //-----------------------------
  const props = defineProps(Props());
  //-----------------------------
  const ponAvatar = require("./images/pon.png");
  //-----------------------------
  const monthLabel = computed(() => {
    const n = props.days;
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return 'месяц';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'месяца';
    return 'месяцев';
  });

  const giftsLabel = computed(() => {
    const n = props.giftsCount;
    const mod10 = n % 10;
    const mod100 = n % 100;
    
    if (mod10 === 1 && mod100 !== 11) return 'подписка';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'подписки';
    return 'подписок';
  })
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>